import { CircularProgress } from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import CustomSwitch from '../../../components/custom/CustomSwitch';
import MarketingService from '../../../services/marketingService';
import { identifyVenue, trackEvent } from '../../../utils/mixpanelUtil';

/**
 * Toggle component for changing promotion/discount/coupon status
 * @param {Object} props 
 * @param {string} props.type - 'promotion', 'discount', or 'coupon'
 * @param {Object} props.item - The item containing id and status
 * @param {Function} props.onToggleComplete - Callback after toggle completes
 */
const StatusToggle = ({ type, item, onToggleComplete }) => {
   const [loading, setLoading] = useState(false);
   const [isActive, setIsActive] = useState(Boolean(item?.status));
   const { short_code } = useSelector((state) => state.app);

   const handleToggle = () => {
      if (loading) return;

      setLoading(true);
      const newStatus = !isActive;

      let updateMethod;
      let trackingElement;

      // Select the appropriate service method and tracking element
      switch (type) {
         case 'promotion':
            updateMethod = MarketingService.UpdatePromotionStatus;
            trackingElement = 'promotions';
            break;
         case 'discount':
            updateMethod = MarketingService.UpdateDiscountStatus;
            trackingElement = 'discounts';
            break;
         case 'coupon':
            updateMethod = MarketingService.UpdateCouponStatus;
            trackingElement = 'coupons';
            break;
         default:
            console.error('Invalid toggle type');
            setLoading(false);
            return;
      }

      updateMethod(item.id, newStatus)
         .then(() => {
            setIsActive(newStatus);
            identifyVenue(short_code);
            trackEvent('marketing service', {
               action_category: 'update_status',
               action_outcome: 'success',
               interaction_element: trackingElement,
            });

            const mType = type === 'promotion' ? type : (type === 'coupon' ? 'coupons' : 'discounts');

            NotificationManager.success(
               t(`marketing.promotions.${mType}.${type}_status_updated`)
            );

            if (onToggleComplete) {
               onToggleComplete(newStatus);
            }
         })
         .catch((err) => {
            identifyVenue(short_code);
            trackEvent('marketing service', {
               action_category: 'update_status',
               action_outcome: 'fail',
               interaction_element: trackingElement,
            });

            NotificationManager.error(
               err?.error || t('common.error_generic')
            );
         })
         .finally(() => {
            setLoading(false);
         });
   };

   return (
      <div className="flex items-center">
         {loading ? (
            <CircularProgress size={24} />
         ) : (
            <CustomSwitch
               active={isActive}
               onClick={handleToggle}
            />
            // <Switch
            //    checked={isActive}
            //    onChange={handleToggle}
            //    // color="primary"
            //    size="small"
            // />
         )}
      </div>
   );
};

export default StatusToggle;